<div class="bg-dark min-h-screen">
  <div class="container mx-auto px-4 py-16 text-light">
    <div class="max-w-4xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-6 text-primary text-center">Veelgestelde Vragen</h1>
      <p class="text-lg md:text-xl mb-12 text-center text-gray-300">
        Vind snel antwoorden op de meest gestelde vragen
      </p>
      
      <div class="space-y-4">
        <div *ngFor="let faq of faqs; let i = index" class="bg-dark-light rounded-lg overflow-hidden border border-light/10 hover:border-primary/50 transition-all duration-300">
          <button
            (click)="toggle(i)"
            class="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-dark transition-colors"
          >
            <span class="font-semibold text-lg text-light pr-4">{{ faq.question }}</span>
            <span class="text-primary text-2xl font-bold flex-shrink-0">{{ expandedIndex === i ? '−' : '+' }}</span>
          </button>
          <div *ngIf="expandedIndex === i" class="px-6 py-5 bg-dark border-t border-light/10">
            <p class="text-gray-300 leading-relaxed">{{ faq.answer }}</p>
          </div>
        </div>
      </div>

      <!-- Help Section -->
      <div class="mt-12 bg-dark-light p-8 rounded-lg border border-light/10 text-center">
        <h3 class="text-2xl font-semibold mb-4 text-light">Nog steeds vragen?</h3>
        <p class="text-gray-300 mb-6">
          Kunt u het antwoord niet vinden? Neem gerust contact met ons op.
        </p>
        <a routerLink="/contact" class="bg-primary text-light px-8 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-all duration-300 inline-block">
          Neem Contact Op
        </a>
      </div>
    </div>
  </div>
</div>

